import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';

export const getIsLabelModified = ({
  iri,
  isNewConcept,
  diagram,
}: {
  iri: string;
  isNewConcept: boolean;
  diagram: DiagramSnapshot;
}) => {
  const currentLabel = diagram.model.modelData.labelsByIri[iri];
  const previousLabel =
    diagram.model.modelData.draftData?.prevModelData.labelsByIri[iri];
  return Boolean(
    (isNewConcept && currentLabel) || currentLabel !== previousLabel
  );
};

export const getIsDescriptionModified = ({
  iri,
  isNewConcept,
  diagram,
}: {
  iri: string;
  isNewConcept: boolean;
  diagram: DiagramSnapshot;
}) => {
  const currentDesecription = diagram.model.modelData.descriptionsByIri[iri];
  const previousDesecription =
    diagram.model.modelData.draftData?.prevModelData.descriptionsByIri[iri];
  return Boolean(
    (isNewConcept && currentDesecription) ||
      currentDesecription !== previousDesecription
  );
};

export const getIsColorIdModified = ({
  iri,
  isNewConcept,
  diagram,
}: {
  iri: string;
  isNewConcept: boolean;
  diagram: DiagramSnapshot;
}) => {
  const currentColorId = diagram.model.modelData.colorIdsByIri[iri];
  const previousColorId =
    diagram.model.modelData.draftData?.prevModelData.colorIdsByIri[iri];
  return Boolean(
    (isNewConcept && currentColorId) || currentColorId !== previousColorId
  );
};
